module.exports = "<div class=\"tag --text-small --text-bold\" ng-class=\"::{'tag-error': !$ctrl.valido, 'tag-success': $ctrl.valido}\"\r\n    title=\"{{::$ctrl.mensaje}}\">\r\n  <i class=\"fa fa-fw\" ng-class=\"::{'fa-times-circle': !$ctrl.valido, 'fa-check-circle': $ctrl.valido}\"></i>\r\n  <span>{{::$ctrl.etiqueta}}</span>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/recursoshumanos/components/comparativaSuaNomina/lista/item/validacion/template.html
// module id = 713
// module chunks = 0